import { createTheme, ThemeProvider } from '@mui/material/styles';
import { viVN } from '@mui/material/locale';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import moment from 'moment-timezone';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import {
    Grid,
    List,
    ListItemText,
    ListItemIcon,
    ListItemButton,
    Button,
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    TextField,
    Typography,
    CircularProgress,
    InputAdornment,
    Card,
    CardActions,
    CardContent,
    Tooltip,
    IconButton,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SubCard from 'ui-component/cards/SubCard';
import useConfig from 'hooks/useConfig';
import { useDispatch, useSelector } from 'react-redux';
// import { useDispatch, useSelector } from 'store';
import React, { useEffect } from 'react';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
// project imports
// assets
import WebAssetTwoToneIcon from '@mui/icons-material/WebAssetTwoTone';
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import ShareTwoToneIcon from '@mui/icons-material/ShareTwoTone';
import 'react-lazy-load-image-component/src/effects/blur.css';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone';
// REMOVED: AWS SDK - migrated to Firebase Storage
// import AWS from 'aws-sdk';
import { fetchProjects } from 'store/slices/project';
import SettingsIcon from '@mui/icons-material/Settings';
import ShareIcon from '@mui/icons-material/Share';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { fetchVectors } from 'store/slices/vector';
// import { fetchUrlitem, fetchSitemap, insertSitemap } from 'store/slices/sitemap';
import ProjectProfileCard from './ProjectProfileCard';
import {
    InsertLinkTwoTone,
    UploadFileTwoTone
} from '@mui/icons-material';
import TableSitemap from './TableSitemap';
import TablePage from './TablePage';
import TableUploadFile from './TableUploadFile';
import Upload from './upload/Upload';
// ==============================|| ANALYTICS DASHBOARD ||============================== //
// MIGRATED: AWS SDK removed, backend now uses Firebase Storage (GCS)
// Legacy stub so dead S3 callbacks keep compiling and fail gracefully if invoked.
const s3 = {
    upload: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
    deleteObject: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
    deleteObjects: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
    putObject: (_, cb) => cb && cb(new Error('AWS S3 disabled')),
    listObjects: (_, cb) => cb && cb(new Error('AWS S3 disabled'), { Contents: [] }),
    listObjectsV2: (_, cb) => cb && cb(new Error('AWS S3 disabled'), { Contents: [], CommonPrefixes: [] }),
    getObject: (_, cb) => cb && cb(new Error('AWS S3 disabled'), null),
    getSignedUrlPromise: () => Promise.reject(new Error('AWS S3 disabled'))
};

// const API_URL = 'https://httpbin.org/post'
// const API_METHOD = 'POST'
const STATUS_IDLE = 0;
const STATUS_UPLOADING = 1;
// table columns
export const columns = [
    { field: 'id', headerName: 'STT', width: 70 },
    {
        field: 'name',
        headerName: 'Tên tài liệu',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 300
        // valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`
    },
    { field: 'type', headerName: 'Định dạng', width: 130 },
    { field: 'size', headerName: 'Dung lượng', width: 130 },
    {
        field: 'label',
        headerName: 'Nhãn',
        width: 90
    },
    {
        field: 'created_date',
        headerName: 'Thời gian',
        width: 300
    }
];

// table data
// export const rows = [
//     { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
//     { id: 2, lastName: 'Lancaster', firstName: 'Cersei', age: 42 },
//     { id: 3, lastName: 'Lancaster', firstName: 'Jaime', age: 45 },
//     { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
//     { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
//     { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
//     { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
//     { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
//     { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 }
// ];

const options = [
    { label: 'Tất cả thời gian', value: 'all' },
    { label: '7 ngày trước', value: '7' },
    { label: '30 ngày trước', value: '30' },
    { label: '90 ngày trước', value: '90' }
];

const sortOptions = [
    { label: 'Xếp theo mới nhất', value: 'desc' },
    { label: 'Xếp theo cũ nhất', value: 'asc' }
];
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) =>
    order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const ProjectManagement = () => {
    const theme = useTheme();
    const locale = createTheme(
        {
            // palette: {
            //     primary: { main: '#1976d2' }
            // }
        },
        viVN
    );
    const cardStyle = {
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
        border: '1px solid',
        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[100],
        minHeight: '100%'
    };
    const CardContentStyle = {
        padding: '16px',
        paddingLeft: '40px'
    };

    // const navRef = useRef(null);
    const apiHost = process.env.REACT_APP_API_URL;
    const embeddingsName = 'openai_text-embedding-ada-002';

    // REMOVED: S3 bucket - using Firebase Storage
    // const S3_BUCKET = 'youteach.ai';
    // REMOVED: AWS region
    // const REGION = 'ap-southeast-1';
    const dispatch = useDispatch();
    const vectorsState = useSelector((state) => state.vector);
    const sitemapsState = useSelector((state) => state.sitemap);
    const projectsState = useSelector((state) => state.project);

    // REMOVED: AWS configuration
    // AWS.config.update({
    //         accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    //         secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    //         s3Url: 'http://youteach.ai.s3-website-ap-southeast-1.amazonaws.com',
    //         bucketName: S3_BUCKET,
    //         region: REGION
    //     });

    // REMOVED: S3 client - now using Firebase Storage
    // const s3 = new AWS.S3();

    // const initialProjectsState = useSelector((state) => state.project);
    // console.log(initialProjectsState)
    const [files, setFiles] = React.useState([]);
    const [status, setStatus] = React.useState(STATUS_IDLE);
    const [project, setProject] = React.useState('document');
    const [projects, setProjects] = React.useState([]);
    // const [initialProjects, setInitialProjects] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openImage, setOpenImage] = React.useState(false);

    const [vector, setVector] = React.useState([]);
    const [sitemap, setSitemap] = React.useState('');
    const [sitemaps, setSitemaps] = React.useState([]);
    const [urlitems, setUrlitems] = React.useState([]);

    const [FolderName, setFolderName] = React.useState('');
    const [subObjects, setSubObjects] = React.useState([]);
    const [Folders, setFolders] = React.useState([]);
    const [Objects, setObjects] = React.useState([]);
    const [Images, setImages] = React.useState([]);
    const [Image, setImage] = React.useState([]);

    const [rows, setRows] = React.useState([]);
    const [isSetting, setSetting] = React.useState(false);
    const [isLoading, setLoading] = React.useState(true);
    const [isRename, setRename] = React.useState(false);
    const [isMatchDelete, setMatchDelete] = React.useState(false);
    const [isOpenFolder, setOpenFolder] = React.useState(false);

    const prevFolders = React.useRef([]);
    const prevLoading = React.useRef(null);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isShowUploadFile, setShowUploadFile] = React.useState(false);
    const [isShowPage, setShowPage] = React.useState(false);
    const [timeRange, setTimeRange] = React.useState('all');
    const [sort, setSort] = React.useState('desc');
    const [search, setSearch] = React.useState('');
    const [openSetting, setOpenSetting] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [projectName, setProjectName] = React.useState('');
    const [sourceValueRadio, setSourceValueRaido] = React.useState('my-document');
    const [modalValueRadio, setModalValueRadio] = React.useState('gpt-4.0 turbo');
    const [referenceValueRadio, setReferenceValueRadio] = React.useState('reference');
    const [isOpenAddProject, setOpenAddProject] = React.useState(false);
    const [isCopy, setCopy] = React.useState(false);
    const { borderRadius } = useConfig();
    const [isLoadingFile, setLoadingFile] = React.useState(true);
    const [value, setValue] = React.useState('1');
    const [uploadModalState, setUploadModalState] = React.useState('INACTIVE');

    // useEffect(() => {
    //     // setVector(vectorsState?.vectors.id);
    //     // dispatch(fetchSitemap(project, FolderName, vectorsState?.vectors.id));
    //     // dispatch(fetchUrlitem(project, vectorsState?.vectors.id));
    //     // setSitemaps(sitemapsState?.sitemaps);
    //     // console.log('vector_id' , vectorsState?.vectors.id)
    //     setSetting(false);
    // }, [vectorsState?.vectors.id]);

    useEffect(() => {
        setSitemaps(sitemapsState?.sitemaps);
        setUrlitems(sitemapsState?.urlitems);
        // console.log('sitemap', sitemapsState?.sitemaps);
        // console.log('urlitems', sitemapsState?.urlitems);
    }, [sitemapsState]);

    // React.useEffect(() => {
    //     dispatch(fetchProjects());
    // }, [dispatch]);

    useEffect(() => {
        dispatch(fetchProjects(project, 'local'));
    }, [project]);

    // React.useEffect(() => {
    //     setInitialProjects(initialProjectsState?.projects);
    // }, [initialProjects]);

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };
    React.useEffect(() => {
        prevFolders.current = Folders;
        prevLoading.current = isLoading;
    }, [Folders, isLoading]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const renderProjectList = (projects) =>
        [...projects].map((f, i) => {
            return (
                <Grid container spacing={2} key={i}>
                    <Grid item xs={12}>
                        <SubCard
                            title={
                                <Stack>
                                    <Typography variant="h3">{f.name.replaceAll('/', '')}</Typography>
                                    <Typography variant="body1">{f.description}</Typography>
                                </Stack>
                            }
                            secondary={
                                <Grid container spacing={2}>
                                    <Grid item sx={{ textAlign: 'right' }}>
                                        <Typography variant="body2">Ngày tạo: {moment(f.created_date).format('DD/MM/YYYY')}</Typography>
                                        <Tooltip title="Cài đặt trợ lý">
                                            <IconButton size="small">
                                                <SettingsIcon
                                                    onClick={async () => {
                                                        setSetting(true);
                                                        setOpenSetting(true);
                                                        setValue('1');
                                                        setSelectedIndex(0);
                                                        setFolderName(f.name);
                                                        // dispatch(fetchVectors(f.name));
                                                        fetchFiles(project, f.name);
                                                        setVector(vectorsState?.vectors.id);
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Chia sẻ trợ lý">
                                            <IconButton size="small">
                                                <ShareIcon
                                                    onClick={() => {
                                                        setSetting(true);
                                                        setOpenSetting(true);
                                                        setSelectedIndex(0);
                                                        setValue('4');
                                                        setSelectedIndex(0);
                                                        setFolderName(f.name);
                                                        // dispatch(fetchVectors(f.name));
                                                        setVector(vectorsState?.vectors.id);
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Xóa trợ lý">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setFolderName(f.name);
                                                    handleClickOpenDelete();
                                                }}
                                                setFol
                                            >
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            }
                            sx={{ mt: gridSpacing }}
                        >
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12} lg={3} md={6}>
                                    <Card sx={{ ...cardStyle, marginLeft: '10px', boxShadow: '-10px 0px 0px 0px #00C853' }}>
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    {/* <Typography variant="h5" sx={{ color: theme.palette.text.dark }}>
                                                Card Title
                                            </Typography> */}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body1">Số tài liệu đã upload</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h1">{f.upload_num}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={CardContentStyle}>
                                            <Button
                                                variant="text"
                                                color="success"
                                                onClick={() => {
                                                    fetchFiles(project, f.name);
                                                    setShowUploadFile(true);
                                                    setFolderName(f.name);
                                                }}
                                            >
                                                Xem chi tiết...
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                    <Card sx={{ ...cardStyle, marginLeft: '10px', boxShadow: '-10px 0px 0px 0px #673AB7' }}>
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    {/* <Typography variant="h5" sx={{ color: theme.palette.text.dark }}>
                                                Card Title
                                            </Typography> */}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body1">Số url của Sitemaps</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h1">{f.url_num}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={CardContentStyle}>
                                            <Button
                                                variant="text"
                                                color="secondary"
                                                onClick={() => {
                                                    setShowPage(true);
                                                    // fetchUrlitem(project, vectorsState?.vectors.id);
                                                }}
                                            >
                                                Xem chi tiết...
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                    <Card sx={{ ...cardStyle, marginLeft: '10px', boxShadow: '-10px 0px 0px 0px #D84315' }}>
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    {/* <Typography variant="h5" sx={{ color: theme.palette.text.dark }}>
                                                Card Title
                                            </Typography> */}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body1">Số lượng từ đã chỉ mục</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h1">{f.word_indexed}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={CardContentStyle}>
                                            <Button variant="text" color="secondary" style={{ display: 'none' }}>
                                                Xem chi tiết...
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                    <Card sx={{ ...cardStyle, marginLeft: '10px', boxShadow: '-10px 0px 0px 0px #FFC107' }}>
                                        <CardContent sx={CardContentStyle}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    {/* <Typography variant="h5" sx={{ color: theme.palette.text.dark }}>
                                                Card Title
                                            </Typography> */}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body1">Số truy vấn tháng này</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="h1">{f.query_num}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions sx={CardContentStyle}>
                                            <Button variant="text" color="secondary" style={{ display: 'none' }}>
                                                Xem chi tiết...
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button variant="outlined" fullWidth size="large">
                                        CHAT VỚI YOUTEACH.AI
                                    </Button>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>
                </Grid>
            );
        });

    const renderProjectSetting = () => {
        return (
            <>
                <Button
                    variant=""
                    style={{
                        color: 'white',
                        backgroundColor: 'grey'
                    }}
                    onClick={() => {
                        setOpenSetting(false);
                        setSelectedIndex(0);
                        setValue(1);
                        setCopy(false);
                    }}
                >
                    Trở về
                </Button>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="Thông tin chung" value="1" />
                            <Tab label="Dữ liệu" value="2" />
                            <Tab label="Chatbot" value="3" />
                            <Tab label="Chia sẻ" value="4" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <Grid container spacing={4}>
                            <Grid item lg={4} xs={12}>
                                <SubCard title="Ảnh đại diện">
                                    <ProjectProfileCard role="Tải lên/ Thay đổi ảnh đại diện trợ lý" />
                                </SubCard>
                            </Grid>
                            <Grid item lg={8} xs={12}>
                                <SubCard title="Thông tin trợ lý">
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <TextField
                                                disabled
                                                label="Tên trợ lý"
                                                id="project"
                                                name="project"
                                                value={FolderName.replace('/', '')}
                                                sx={{ m: 2, width: '90%' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                disabled
                                                label="Ngôn ngữ"
                                                id="language"
                                                name="language"
                                                value="Tiếng Việt"
                                                sx={{ m: 2, width: '90%' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    console.log('Cập nhật thông tin chung');
                                                }}
                                            >
                                                Cập nhật thông tin
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </SubCard>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value="2">
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <SubCard>
                                        <List component="nav" aria-label="main mailbox folders">
                                            <ListItemButton
                                                selected={selectedIndex === 0}
                                                onClick={(event) => handleListItemClick(event, 0)}
                                                sx={{ borderRadius: `${borderRadius}px` }}
                                            >
                                                <ListItemIcon>
                                                    <DescriptionTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Sitemap" secondary="Cung cấp dữ liệu sitemap" />
                                            </ListItemButton>
                                            <ListItemButton
                                                selected={selectedIndex === 1}
                                                onClick={(event) => handleListItemClick(event, 1)}
                                                sx={{ borderRadius: `${borderRadius}px`, mt: 0.625 }}
                                            >
                                                <ListItemIcon>
                                                    <UploadFileTwoTone sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Upload file" secondary="Cung cấp file từ thiết bị" />
                                            </ListItemButton>
                                        </List>
                                    </SubCard>
                                </Grid>
                                <Grid item xs={8}>
                                    {selectedIndex === 0 && (
                                        <SubCard title="Thông tin File tải lên">
                                            <Grid container>
                                                <ThemeProvider theme={locale}>
                                                    <TableSitemap />
                                                </ThemeProvider>
                                                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            console.log('Cập nhật thông tin chung');
                                                        }}
                                                    >
                                                        Thêm mới Sitemap
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                    {selectedIndex === 1 && (
                                        <SubCard title="Thông tin File tải lên">
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <ThemeProvider theme={locale}>
                                                        <TableUploadFile
                                                            onClick={() => {}}
                                                            folderName={FolderName.replace('/', '')}
                                                            dataUploadFile={rows}
                                                            isSetting={true}
                                                        />
                                                    </ThemeProvider>
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            setUploadModalState('ACTIVE');
                                                            console.log(FolderName);
                                                        }}
                                                    >
                                                        Thêm mới Files
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </TabPanel>
                    <TabPanel value="3">
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <SubCard>
                                        <List component="nav" aria-label="main mailbox folders">
                                            <ListItemButton
                                                selected={selectedIndex === 0}
                                                onClick={(event) => handleListItemClick(event, 0)}
                                                sx={{ borderRadius: `${borderRadius}px` }}
                                            >
                                                <ListItemIcon>
                                                    <WebAssetTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Cài đặt giao diện" secondary="Quản lý hội thoại của Chatbot" />
                                            </ListItemButton>
                                            <ListItemButton
                                                selected={selectedIndex === 1}
                                                onClick={(event) => handleListItemClick(event, 1)}
                                                sx={{ borderRadius: `${borderRadius}px`, mt: 0.625 }}
                                            >
                                                <ListItemIcon>
                                                    <ChatBubbleTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Cài đặt đoạn hội thoại" secondary="Quản lý hội thoại của Chatbot" />
                                            </ListItemButton>
                                        </List>
                                    </SubCard>
                                </Grid>
                                <Grid item xs={8}>
                                    {selectedIndex === 0 && (
                                        <SubCard title="Thông tin mặc định Chatbot">
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        disabled
                                                        label="Màu nền Chatbot"
                                                        id="chatbot_bg"
                                                        name="chatbot_bg"
                                                        value={'#FFFFFF'}
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        disabled
                                                        label="Câu chào mặc định"
                                                        id="chatbot_bg"
                                                        name="chatbot_bg"
                                                        value={'Xin chào, Tôi có thể giúp được gì cho bạn?'}
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        disabled
                                                        label="Khi Chatbot không kết nối được, mặc định trả lời"
                                                        id="chatbot_bg"
                                                        name="chatbot_bg"
                                                        value={
                                                            'Ups! Bot trò chuyện đang ngủ. Điều này thường xảy ra khi OpenAI bị lỗi! Vui lòng thử lại sau.'
                                                        }
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                                                    <Button
                                                        disabled
                                                        variant="contained"
                                                        onClick={() => {
                                                            console.log('Cập nhật Chatbot');
                                                        }}
                                                    >
                                                        Cập nhât Chatbot
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                    {selectedIndex === 1 && (
                                        <SubCard title="Thông tin mặc định chatbot">
                                            <Grid container>
                                                <Grid item>
                                                    {' '}
                                                    <Typography variant="caption">Nguồn</Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ marginTop: '4px' }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            disabled
                                                            columns
                                                            aria-label="source"
                                                            value={sourceValueRadio}
                                                            onChange={(e) => setSourceValueRaido(e.target.value)}
                                                            name="row-radio-buttons-group"
                                                        >
                                                            <FormControlLabel
                                                                value="my-document"
                                                                control={<Radio disabled />}
                                                                label="Tài liệu của trợ lý"
                                                            />
                                                            <FormControlLabel
                                                                value="gpt-document"
                                                                control={<Radio disabled />}
                                                                label="Tài liệu của ChatGPT"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid container>
                                                <Grid item>
                                                    {' '}
                                                    <Typography variant="caption">Model</Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ marginTop: '4px' }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            disabled
                                                            columns
                                                            aria-label="source"
                                                            value={modalValueRadio}
                                                            onChange={(e) => setModalValueRadio(e.target.value)}
                                                            name="row-radio-buttons-group"
                                                        >
                                                            <FormControlLabel
                                                                value="gpt-3.5"
                                                                control={<Radio disabled />}
                                                                label="GPT - 3.5"
                                                            />
                                                            <FormControlLabel
                                                                value="gpt-4.0 turbo"
                                                                control={<Radio disabled />}
                                                                label="GPT - 4.0 Turbo"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid container>
                                                <Grid item>
                                                    {' '}
                                                    <Typography variant="caption">Trích dẫn</Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ marginTop: '4px' }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            disabled
                                                            columns
                                                            aria-label="reference"
                                                            value={referenceValueRadio}
                                                            onChange={(e) => setReferenceValueRadio(e.target.value)}
                                                            name="row-radio-buttons-group"
                                                        >
                                                            <FormControlLabel
                                                                value="reference"
                                                                control={<Radio disabled />}
                                                                label="Cần trích dẫn cho câu trả lời"
                                                            />
                                                            <FormControlLabel
                                                                value="no-reference"
                                                                control={<Radio disabled />}
                                                                label="Không cần trích dẫn"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </TabPanel>
                    <TabPanel value="4">
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <SubCard>
                                        <List component="nav" aria-label="main mailbox folders">
                                            <ListItemButton
                                                selected={selectedIndex === 0}
                                                onClick={(event) => handleListItemClick(event, 0)}
                                                sx={{ borderRadius: `${borderRadius}px` }}
                                            >
                                                <ListItemIcon>
                                                    <ShareTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Share Link" secondary="Chia sẻ Chatbot với mọi người" />
                                            </ListItemButton>
                                            {/* <ListItemButton
                                                selected={selectedIndex === 1}
                                                onClick={(event) => handleListItemClick(event, 1)}
                                                sx={{ borderRadius: `${borderRadius}px`, mt: 0.625 }}
                                            >
                                                <ListItemIcon>
                                                    <DescriptionTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Embed" secondary="Dính Chatbot vào website của bạn" />
                                            </ListItemButton> */}
                                            <ListItemButton
                                                selected={selectedIndex === 1}
                                                onClick={(event) => handleListItemClick(event, 1)}
                                                sx={{ borderRadius: `${borderRadius}px`, mt: 0.625 }}
                                            >
                                                <ListItemIcon>
                                                    <ListAltTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                                </ListItemIcon>
                                                <ListItemText primary="Chat trực tiếp" secondary="Chat trực tiếp trên website của bạn" />
                                            </ListItemButton>
                                        </List>
                                    </SubCard>
                                </Grid>
                                <Grid item xs={8}>
                                    {selectedIndex === 0 && (
                                        <SubCard title="Thông tin chia sẻ">
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <Typography variant="h4" gutterBottom>
                                                        Chia sẻ công khai
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="caption" mt={2} gutterBottom>
                                                        Bạn có thể gửi link này cho đối tác, khách hàng của mình
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        label="Chia sẻ công khai"
                                                        id="bot"
                                                        name="bot"
                                                        value={
                                                            'https://dev.youteach.ai:4001/pages/bot?id=' + String(vector)
                                                            // + '&project=' +
                                                            // FolderName.replaceAll('/', '')
                                                        }
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="button-copy-content"
                                                                        onClick={handleCopyLink}
                                                                        edge="end"
                                                                        sx={{ marginRight: '0.5px' }}
                                                                    >
                                                                        <Tooltip title={isCopy === false ? 'Copy link' : 'Copied'}>
                                                                            <ContentCopyTwoToneIcon fontSize="small" />
                                                                        </Tooltip>
                                                                    </IconButton>
                                                                    <IconButton
                                                                        aria-label="button-copy-content"
                                                                        onClick={(e) => console.log(e.target.value)}
                                                                        edge="end"
                                                                        href={
                                                                            'https://dev.youteach.ai:4001/pages/bot?id=' + String(vector)
                                                                            // + '&project=' +
                                                                            // FolderName.replaceAll('/', '')
                                                                        }
                                                                        target="_blank"
                                                                    >
                                                                        <Tooltip title="Follow link">
                                                                            <InsertLinkTwoTone fontSize="small" />
                                                                        </Tooltip>
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                    {/* {selectedIndex === 1 && <div>Chat trực tiếp</div>} */}
                                    {selectedIndex === 1 && (
                                        <SubCard title="Thông tin chia sẻ">
                                            <Grid item>
                                                <Grid item>
                                                    <TextField
                                                        disabled
                                                        label="Tên trợ lý"
                                                        id="project"
                                                        name="project"
                                                        value={FolderName.replace('/', '')}
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <TextField
                                                        label="Chia sẻ nhúng"
                                                        id="embedded"
                                                        name="embedded"
                                                        multiline
                                                        rows={4}
                                                        value={
                                                            '<div id="chatbot-youteach"></div> \n <script src="https://youteach.ai/api/bot?id=' +
                                                            String(vector) +
                                                            '&project=' +
                                                            FolderName.replaceAll('/', '') +
                                                            '"></script>'
                                                        }
                                                        sx={{ m: 2, width: '90%' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </TabPanel>
                </TabContext>
            </>
        );
    };

    const renderButtonStatus = () =>
        status === STATUS_IDLE ? (
            'Send to server'
        ) : (
            <Grid item>
                <CircularProgress aria-label="progress" />
            </Grid>
        );

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };

    const handleClickOpenUpdate = (data) => {
        setOpenUpdate(true);
        setFolderName(data);
        // console.log(data)
    };

    const handleClickOpenDelete = (data) => {
        setOpenDelete(true);
        // setFolderName(data)
        // console.log(data)
    };

    const handleClickOpenFolder = () => {
        setOpenFolder(true);
        setOpenUpdate(false);
        fetchImages();
    };

    const handleUpdateClose = () => {
        setOpenUpdate(false);
    };

    const handleDeleteClose = () => {
        setOpenDelete(false);
        setOpenUpdate(false);
    };

    const handleUpdateSubmit = () => {
        // console.log(FolderName);
    };

    const handleDeleteFolder = () => {
        const params = {
            Bucket: 'kmou-dp',
            Key: 'Marine-Parts/' + project + '/' + FolderName
        };

        s3.deleteObject(params, function (err, data) {
            if (err)
                console.log(err, err.stack); // an error occurred
            else {
                // console.log(Objects)
                console.log('Success'); // successful response
                fetchFolders(project);
            }
        });
    };

    const handleAddFolder = () => {
        const params = {
            Bucket: 'kmou-dp',
            Key: 'Marine-Parts/' + project + '/' + FolderName + '/'
        };

        let err = 0;
        subObjects.Contents.map((data, index) => {
            // console.log(data.Key.split("/")[2] === FolderName)
            if (data.Key.split('/')[2] === FolderName) {
                err = 1;
            }
        });

        if (err === 0) {
            s3.putObject(params, function (err, data) {
                if (err)
                    console.log(err, err.stack); // an error occurred
                else {
                    // console.log(Objects)
                    console.log('Success'); // successful response
                    fetchFolders(project);
                }
            });
        } else {
            console.log('Exists');
        }
    };

    const fetchFolders = (project) => {
        const params = {
            Bucket: 'youteach.ai',
            Prefix: localStorage.getItem('user_token') + '/' + project + '/',
            Delimiter: '/'
        };
        // console.log(params);
        setLoading(true);
        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                // console.log(data)
                setSubObjects(data);
                // setFolders([])
                let Folders = [];
                data?.CommonPrefixes?.map((data, index) => {
                    // console.log(data)
                    if (data.Prefix.split(localStorage.getItem('user_token') + '/' + project + '/')[1] !== '') {
                        Folders.push(data.Prefix.split(localStorage.getItem('user_token') + '/' + project + '/')[1]);
                    }
                });

                let foldersWithData = Folders.map((f, i) => {
                    // console.log(projectsState.projects.filter(project => `${project.project_name}/` === f)[0]);
                    const mappedProject = projectsState.projects.filter((project) => `${project.project_name}/` === f)[0];

                    return {
                        id: i + 1,
                        name: f,
                        description: 'Mô tả của trợ lý',
                        url_num: 2000,
                        word_indexed: mappedProject !== undefined ? mappedProject.project_word_indexed : '',
                        query_num: mappedProject !== undefined ? mappedProject.project_query_month : '',
                        upload_num: mappedProject !== undefined ? mappedProject.project_document_num : '',
                        // created_date: moment(new Date()).format('YYYY-MM-DD'),
                        created_date: mappedProject !== undefined ? mappedProject.created_date : '',
                        created_by: '2023-11-30'
                    };
                });

                setObjects(foldersWithData);
                console.log(foldersWithData);
            }
        });

        setLoading(false);
        setOpenFolder(true);
    };

    const fetchFiles = (project, folder) => {
        const params = {
            Bucket: 'youteach.ai',
            Prefix: localStorage.getItem('user_token') + '/' + project + '/' + folder,
            Delimiter: '/'
        };

        setLoading(true);

        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                // console.log(data)
                // setSubObjects(data)
                // setFolders([])
                let Files = [];
                let rows = [];
                data?.Contents?.map((data, index) => {
                    // console.log(data)
                    if (data.Key.split(localStorage.getItem('user_token') + '/' + project + '/' + folder)[1] !== '') {
                        const name = data.Key.split(localStorage.getItem('user_token') + '/' + project + '/' + folder)[1];
                        Files.push(name);
                        rows.push({
                            id: index,
                            name: name,
                            type: name.split('.')[name.split('.').length - 1],
                            crawl_status: 'done(dummy)',
                            index_status: 'done(dummy)',
                            word_num: '123123(dmmy)',
                            created_date: moment(data['LastModified']).tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY HH:mm:ss'),
                            size: String(parseFloat(data['Size'] / 1024 / 1024).toFixed(2)) + ' MB'
                        });
                    }
                });
                // setObjects(Folders)
                // console.log(Files)
                setRows(rows);
                setLoading(false);
                setOpenFolder(true);
                console.log(rows);
            }
        });
    };

    const fetchImages = () => {
        const params = {
            Bucket: 'kmou-dp',
            Prefix: 'Marine-Parts/' + project + '/' + FolderName,
            Delimiter: ''
        };

        // setLoading(true);

        s3.listObjectsV2(params, async (err, data) => {
            if (err) {
                console.log(err);
            } else {
                await new Promise((resolve) => {
                    let Images = [];
                    data.Contents.map(async (data, index) => {
                        if (data.Key.split('Marine-Parts/' + project + '/' + FolderName)[1] !== '') {
                            const params = {
                                Bucket: 'kmou-dp',
                                Key: data.Key
                            };

                            await s3.getSignedUrlPromise('getObject', params, (err, data) => {
                                if (err) {
                                    console.log(err);
                                } else {
                                    Images.push(data);
                                }
                            });
                        }
                    });

                    resolve(Images);
                }).then((Images) => {
                    setImages(Images);
                    console.log(Images);
                });
                // setLoading(false)
            }
        });
    };

    const handleAddProject = async () => {
        if (FolderName === '') {
            alert('Vui lòng điền tên trợ lý');
        } else {
            const formData = new FormData();
            formData.append('name', FolderName);
            formData.append('user', 'local');
            formData.append('user_token', localStorage.getItem('user_token'));
            formData.append('project', project);

            await new Promise(async (resolve) => {
                const params = {
                    Bucket: 'youteach.ai',
                    Key: localStorage.getItem('user_token') + '/' + project + '/' + FolderName + '/'
                };
                console.log(params);
                s3.putObject(params, function (err, data) {
                    if (err)
                        console.log(err, err.stack); // an error occurred
                    else {
                        console.log('Success'); // successful response
                        resolve('Uploaded File !');
                    }
                });
            }).then((result) => {
                console.log(result);
            });

            const xhr = new XMLHttpRequest();
            xhr.onload = () => {
                setOpenAddProject(false);
            };
            xhr.open('POST', `${apiHost + '/api/projects'}`);
            xhr.send(formData);
            fetchFolders(project);
        }
    };

    const handleDeleteClick = (FolderName) => {
        const docPath = 'indexes/' + 'local' + '/' + localStorage.getItem('user_token') + '/' + project + '/' + FolderName.replace('/', '');

        fetch(`${apiHost}/api/delete_old?path=${docPath}`, {
            method: 'GET'
        })
            .then(() => {
                // remove the image element from the DOM
                // const imageElement = document.querySelector(`#img-${index}`);
                // const parentElement = imageElement.parentNode;
                // parentElement.parentNode?.removeChild(parentElement);

                let params = {
                    Bucket: 'youteach.ai',
                    Prefix: localStorage.getItem('user_token') + '/' + project + '/' + FolderName.replace('/', '')
                };

                s3.listObjects(params, function (err, data) {
                    if (err) return console.log(err);

                    if (data.Contents.length == 0) {
                        s3.deleteObjects(params, function (err, data) {
                            if (err) return console.log(err);
                            else {
                                console.log('Delete Success');
                                fetchFolders(project);
                            }
                        });
                    } else {
                        data.Contents.forEach(function (content) {
                            params = { Bucket: 'youteach.ai' };
                            params.Delete = { Objects: [] };
                            params.Delete.Objects.push({ Key: content.Key });
                        });

                        s3.deleteObjects(params, function (err, data) {
                            if (err) return console.log(err);
                            else {
                                console.log('Delete Success');
                                fetchFolders(project);
                            }
                        });
                    }
                });

                // const params = {
                //   Bucket: 'youteach.ai',
                //   Key: localStorage.getItem('user_token') + '/document/' + doc.name
                // };

                // s3.deleteObject(params, function(err, data) {
                //   if (err) console.log(err, err.stack); // an error occurred
                //   else     console.log("success");           // successful response
                // });
            })
            .catch((error) => console.error(error));
        setOpenDelete(false);
        // fetchFolders(project);
    };

    const handleCopyLink = () => {
        // const link = `http://dev.youteach.ai:3002?id=${String(vector)}&project=${FolderName.replaceAll('/', '')}`;
        const link = `https://dev.youteach.ai:4001/pages/bot?id=${String(vector)}`;
        navigator.clipboard.writeText(link).then(() => {
            setCopy(true);
        });
    };

    return (
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
                {!isShowUploadFile && !openSetting && !isShowPage && (
                    <MainCard
                        title={
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="h3">Tất cả trợ lý</Typography>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={3} sx={{ marginTop: '10px', justifyContent: 'space-between' }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                setOpenAddProject(true);
                                            }}
                                        >
                                            Tạo trợ lý
                                        </Button>
                                    </Grid>
                                    <Grid item xs={9} sx={{ textAlign: 'right' }}>
                                        <Grid>
                                            <Select
                                                value={timeRange}
                                                // onChange={handleTimeRangeChange}
                                                sx={{ width: '200px', marginRight: '10px' }}
                                            >
                                                {options.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                            <Select
                                                value={sort}
                                                // onChange={(e) => {
                                                //     setSort(e.target.value);
                                                //     handleRequestSort(null, 'thoiGianCapNhat');
                                                // }}
                                                sx={{ width: '200px', marginRight: '10px' }}
                                            >
                                                {sortOptions.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <TextField
                                                sx={{ width: '300px', marginRight: '0' }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon fontSize="medium" />
                                                        </InputAdornment>
                                                    )
                                                }}
                                                // onChange={handleSearch}
                                                placeholder="Tìm kiếm"
                                                value={search}
                                                size="medium"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        // secondary={<SecondaryAction link="https://next.material-ui.com/components/cards/" />}
                        sx={{ mt: gridSpacing }}
                    >
                        {renderProjectList(Objects)}
                    </MainCard>
                )}
                {isShowUploadFile && !isLoading && (
                    <TableUploadFile
                        onClick={() => {
                            setShowUploadFile(false);
                        }}
                        folderName={FolderName.replace('/', '')}
                        dataUploadFile={rows}
                        isSetting={false}
                    />
                )}
                {isShowPage && (
                    <TablePage
                        onClick={() => {
                            setShowPage(false);
                        }}
                    />
                )}
                {!isShowUploadFile && openSetting && <Grid>{renderProjectSetting()}</Grid>}
            </Grid>
            {/* All Dialog is defined here */}
            {/* <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                    {open && (
                        <>
                            <DialogTitle id="form-dialog-title">Add Folder</DialogTitle>
                            <DialogContent>
                                <Stack spacing={3}>
                                    <DialogContentText>
                                        <Typography variant="body2" component="span">
                                            Folder Name
                                        </Typography>
                                    </DialogContentText>
                                    <TextField onChange={(e) => { setFolderName(e.target.value) }}
                                        autoFocus size="small" id="fileName" name="fileName" label="Folder Name"
                                        fullWidth />
                                </Stack>
                            </DialogContent>
                            <DialogActions sx={{ pr: 2.5 }}>
                                <Button sx={{ color: theme.palette.error.dark }} onClick={handleClose} color="secondary">
                                    Cancel
                                </Button>
                                <Button variant="contained" size="small" onClick={handleAddFolder}>
                                    Add
                                </Button>
                            </DialogActions>
                        </>
                    )}
                </Dialog> */}
            <Dialog open={openUpdate} onClose={handleUpdateClose} aria-labelledby="form-dialog-title">
                {openUpdate && (
                    <>
                        <DialogTitle id="form-dialog-title">Update Folder</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        Folder Name
                                    </Typography>
                                </DialogContentText>
                                <TextField
                                    disabled={!isRename}
                                    value={FolderName}
                                    onChange={(e) => {
                                        setFolderName(e.target.value);
                                    }}
                                    autoFocus
                                    size="small"
                                    id="fileName"
                                    name="fileName"
                                    label="Folder Name"
                                    fullWidth
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ color: theme.palette.primary.light }}
                                variant="contained"
                                size="small"
                                onClick={handleClickOpenFolder}
                            >
                                Open Folder
                            </Button>
                            {!isRename && (
                                <Button
                                    sx={{ color: theme.palette.info.dark }}
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                        setRename(true);
                                    }}
                                >
                                    Rename Folder
                                </Button>
                            )}
                            {isRename && (
                                <Button variant="contained" size="small" onClick={handleUpdateSubmit}>
                                    Submit
                                </Button>
                            )}
                            <Button
                                sx={{ color: theme.palette.error.dark }}
                                variant="outlined"
                                size="small"
                                onClick={handleClickOpenDelete}
                            >
                                Delete
                            </Button>
                            <Button sx={{ color: theme.palette.secondary.dark }} onClick={handleUpdateClose} color="secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* <Dialog open={openDelete} onClose={handleDeleteClose} aria-labelledby="form-dialog-title">
                {openDelete && (
                    <>
                        <DialogTitle id="form-dialog-title">Delete Folder</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        Type Folder Name To Delete
                                    </Typography>
                                </DialogContentText>
                                <TextField
                                    onChange={(e) => {
                                        if (e.target.value === FolderName) {
                                            setMatchDelete(true);
                                        }
                                    }}
                                    autoFocus
                                    size="small"
                                    id="fileName"
                                    name="fileName"
                                    label="Folder Name"
                                    fullWidth
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button sx={{ color: theme.palette.error.dark }} onClick={handleDeleteClose} color="secondary">
                                Cancel
                            </Button>
                            <Button disabled={!isMatchDelete} variant="contained" size="small" onClick={handleDeleteFolder}>
                                Submit
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog> */}
            <Dialog
                open={openImage}
                onClose={() => {
                    setOpenImage(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {openImage && (
                    <>
                        <DialogTitle id="form-dialog-title">Image</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        <Button variant="text">{Image.split('/')[Image.split('/').length - 1].split('?')[0]}</Button>
                                    </Typography>
                                </DialogContentText>
                                <img alt={Image} src={Image}></img>
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ color: theme.palette.error.dark }}
                                onClick={() => {
                                    setOpenImage(false);
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            <Dialog
                open={isOpenAddProject}
                fullWidth
                onClose={() => {
                    setOpenAddProject(false);
                }}
                aria-labelledby="form-dialog-title"
            >
                {isOpenAddProject && (
                    <>
                        <DialogTitle id="form-dialog-title">Tạo mới trợ lý</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText>
                                    <Typography variant="body2" component="span">
                                        Tạo mới trợ lý với thao tác đơn giản
                                    </Typography>
                                </DialogContentText>
                                <TextField
                                    onChange={(e) => {
                                        setFolderName(e.target.value);
                                    }}
                                    autoFocus
                                    size="small"
                                    id="fileName"
                                    name="fileName"
                                    label="Tên trợ lý"
                                    fullWidth
                                    required
                                    helperText="Tên trợ lý viết liền không dấu"
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ color: theme.palette.error.dark, padding: '6px 16px' }}
                                onClick={() => {
                                    setOpenAddProject(false);
                                }}
                                color="secondary"
                            >
                                Thoát
                            </Button>
                            <Button
                                variant="contained"
                                style={{
                                    color: 'white',
                                    backgroundColor: 'darkblue',
                                    padding: '6px 16px'
                                }}
                                size="small"
                                onClick={handleAddProject}
                            >
                                Tạo mới
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* Dialog Delete Project */}
            <Dialog
                open={openDelete}
                // fullWidth
                onClose={() => {
                    handleDeleteClose();
                }}
                aria-labelledby="form-dialog-delete"
            >
                {openDelete && (
                    <>
                        <DialogTitle align="center" id="form-dialog-delete">
                            Xóa trợ lý
                        </DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                <DialogContentText align="center">
                                    <Typography variant="body2" component="span">
                                        Những dữ liệu liên quan sẽ bị xóa
                                    </Typography>
                                </DialogContentText>
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button
                                sx={{ padding: '6px 16px' }}
                                onClick={() => {
                                    setOpenDelete(false);
                                }}
                                color="secondary"
                            >
                                Hủy bỏ
                            </Button>
                            <Button
                                variant="contained"
                                style={{
                                    color: 'white',
                                    backgroundColor: 'darkblue',
                                    padding: '6px 16px'
                                }}
                                size="small"
                                onClick={(e) => {
                                    handleDeleteClick(FolderName);
                                }}
                            >
                                Xác nhận
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
            {/* Dialog Upload Files */}
            {FolderName !== '' && (
                <Upload
                    projectName={FolderName.replaceAll('/', '')}
                    modalState={uploadModalState}
                    setModalState={setUploadModalState}
                    fetchFile={() => {
                        fetchFiles(project, FolderName);
                    }}
                ></Upload>
            )}
        </Grid>
    );
};

export default ProjectManagement;
